module.exports = __webpack_public_path__ + "assets/img/ttl-footer01.svg";